import { configureStore } from '@reduxjs/toolkit'
import { globalSlice } from './reducers/globalSlice'
import { initialDataSlice } from './reducers/initialDataSlice'
import { facilityListSlice } from './reducers/facilityListSlice'
import { searchDataSlice } from './reducers/searchDataSlice'
import { modalDataSlice } from './reducers/modalDataSlice'
import { getGlobalDataApi } from './actions/getGlobalDataApi'
import { getInitialDataApi } from './actions/getInitialDataApi'
import { getFacilityListApi } from './actions/getFacilityListApi'
import { getCityApi } from './actions/getCityApi'
import { getActivitiesAndFacilitiesApi } from './actions/getActivitiesAndFacilitiesApi'
import { getPrefferedApi } from './actions/getPrefferedApi'

export default function configureAppStore(preloadedState) {
  const store = configureStore({
    reducer: {
      global: globalSlice.reducer,
      initialData: initialDataSlice.reducer,
      facilityList: facilityListSlice.reducer,
      searchData: searchDataSlice.reducer,
      modalData: modalDataSlice.reducer,
      [getGlobalDataApi.reducerPath]: getGlobalDataApi.reducer,
      [getInitialDataApi.reducerPath]: getInitialDataApi.reducer,
      [getFacilityListApi.reducerPath]: getFacilityListApi.reducer,
      [getCityApi.reducerPath]: getCityApi.reducer,
      [getActivitiesAndFacilitiesApi.reducerPath]: getActivitiesAndFacilitiesApi.reducer,
      [getPrefferedApi.reducerPath]: getPrefferedApi.reducer
    },
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware()
        .concat(getGlobalDataApi.middleware)
        .concat(getInitialDataApi.middleware)
        .concat(getFacilityListApi.middleware)
        .concat(getCityApi.middleware)
        .concat(getActivitiesAndFacilitiesApi.middleware)
        .concat(getPrefferedApi.middleware)
    },
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState,
  })

  return store
}
export const { setLang,setLoader } = globalSlice.actions;
export const {setLoading} = facilityListSlice.actions;
export const { setCardsData, clearFilterType, setFilter, removeFilter, clearFilter, setFilterObject,
  setCityData, setActivityFacilityData, setSort, setLocation, toggleLocationModal } = searchDataSlice.actions;
export { getGlobalDataApi } from './actions/getGlobalDataApi';
export { useFetchGlobalDataQuery } from './actions/getGlobalDataApi';
export { getInitialDataApi } from './actions/getInitialDataApi';
export { useFetchInitialDataQuery } from './actions/getInitialDataApi';
export { getCityApi } from './actions/getCityApi';
export { useFetchCityDataQuery } from './actions/getCityApi';
export { getActivitiesAndFacilitiesApi } from './actions/getActivitiesAndFacilitiesApi';
export { useFetchActivitiesDataQuery, useFetchFacilitiesDataQuery } from './actions/getActivitiesAndFacilitiesApi';
export { getFacilityListApi } from './actions/getFacilityListApi';
export { useFetchFacilityListDataMutation } from './actions/getFacilityListApi';
export { getPrefferedApi } from './actions/getPrefferedApi';
export { useFetchPrefferedDataQuery } from './actions/getPrefferedApi';